import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { setAccessToken } from './actions';
import type { AuthTokenState } from './types';

/**
 * Auth token state managed by the auth-api package.
 * This slice manages the JWT access token for HTTP API authentication.
 */
const initialState: AuthTokenState = {
  accessToken: undefined,
};

/**
 * Auth token slice - owns the access token state.
 * This makes the auth-api package self-contained without needing external configuration.
 *
 * Note: This uses 'authToken' as the slice name to avoid conflicts with
 * existing 'auth' slices in apps (which may handle WebSocket auth, etc.)
 */
export const authTokenSlice = createSlice({
  name: 'authToken',
  initialState,
  reducers: {
    clearAccessToken(state) {
      state.accessToken = undefined;
      state.isLoggedOut = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      setAccessToken,
      (state, action: PayloadAction<{ accessToken: string | undefined }>) => {
        state.accessToken = action.payload.accessToken;
        state.isLoggedOut = action.payload.accessToken == null;
      },
    );
  },
});

export const { clearAccessToken } = authTokenSlice.actions;
export const authTokenReducer = authTokenSlice.reducer;
